import {
  EQUIPMENT_SCHEDULE_MAINTENANCE_LIST, 
  EQUIPMENT_SCHEDULE_MAINTENANCE_LIST_SUCCESS, 
  EQUIPMENT_SCHEDULE_MAINTENANCE_LIST_ERROR,
  EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_SET, 
  EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_CHANGE, 
  EQUIPMENT_SCHEDULE_MAINTENANCE_PAGE_SET,
  EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT,
  EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
  EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR,
  EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_SET,
  EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_MODAL_SET,
  EQUIPMENT_SCHEDULE_MAINTENANCE_ADD,
  EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_SUCCESS,
  EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_ERROR,
  EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_CHANGE,
  EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL,
  EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_SUCCESS,
  EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_ERROR,
  EQUIPMENT_SCHEDULE_MAINTENANCE_VIEW_MODAL_SET,
  EQUIPMENT_SCHEDULE_MAINTENANCE_EDIT_CHANGE,
  EQUIPMENT_SCHEDULE_MAINTENANCE_EDIT_MODAL_SET,
  EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE,
  EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE_SUCCESS,
  EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE_ERROR,
  EQUIPMENT_SCHEDULE_MAINTENANCE_VIEW_TAB_SET,
  EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET,
  EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET_SUCCESS,
  EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET_ERROR,
  EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_RESET
} from '../actions';
 
const INIT_STATE = {
  loading: true,
  file: [],
  list: {
    header:{
      name: 'code',
      order:'sorted-asc'
    },
    page:{
      current: 1,
      rows: 10
    }
  },
  add: {
      data: {
        new:{ maintenance_flag: false, maintenance_delay_flag: false, request_date: null,  id_delivery_order_line_lot: null, delivery_order_line_lot: null, id_request_type: null}
      },
      modal: false,
      loading: false,
      message: '',
      url: '',
      type: ''
  },
  error: false,
  search:{
    modal: false,
    init:true,
    data:{
      delivery_order_line_lot: false
    },
    value:{
      delivery_order_line_lot: false,
    },
    delivery_order_line_lot:{
      loading: true,
      list:[],
      message: ''
    }
  },
  detail: {
    data: [],
    tab: 'general',
    loading: true,
  },
  view: {
    loading: true,
    data: [],
    tab: 'general',
    modal: false,
    log: {
      data: [],
      loading: false,
    },
  },
  edit: {
    loading: true,
    data: {
        new: [],
        old: []
    },
    list: {
        status: {
            data: [],
            loading: false,
        }
    },
    modal: false,
    update: {
        loading: false,
        response: '',
        message: ''
    }
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case EQUIPMENT_SCHEDULE_MAINTENANCE_LIST:
      return {
        ...state,
        loading: true,
        list: {
          ...state.list
        }
        
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          ...action.payload
        } 
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_SET:
      return {
        ...state,
        search:{
          ...state.search,
          data: action.payload,
        }
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_CHANGE:
      return {
        ...state,
        search:{
          ...state.search,
          value: action.payload,
        }
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_PAGE_SET:
      return {
        ...state,
        list: {
          ...state.list,
          page: {
            ...state.list.page,
            ... action.payload,
          }
        },
        log: []
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          delivery_order_line_lot:{
            ...state.search.delivery_order_line_lot,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          delivery_order_line_lot:{
            ...state.search.delivery_order_line_lot,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          delivery_order_line_lot:{
            ...state.search.delivery_order_line_lot,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_CHANGE:
      return {
        ...state,
        add: {
          ...state.add,
          data: {
            ...state.add.data,
            new: {
              ...state.add.data.new,
              ...action.payload
            }
          }
        }
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: action.payload
        }
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_MODAL_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: { 
            ...state.add.data,
            new:{ maintenance_flag: false, maintenance_delay_flag: false, request_date: null,  id_delivery_order_line_lot: null, delivery_order_line_lot: null, id_request_type: null}
          },
          modal: action.payload
        }
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_ADD:
      return {
        ...state,
        add: {
          ...state.add, 
          loading: true
        }
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          modal: false,
          loading: false,
          message: action.payload.message,
          id: action.payload.id
        }
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          loading: false,
          message: action.payload.message
        }
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
          data: []
        }
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload
        },
        edit: {
          ...state.edit,
          loading: false,
          data: {
            new: action.payload,
            old: action.payload
          }
        }
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_ERROR:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: []
        }
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_VIEW_MODAL_SET:
      return {
        ...state,
        view: {
          ...state.view,
          modal: action.payload
        }
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_EDIT_MODAL_SET:
      return {
        ...state,
        edit: {
          ...state.edit,
          modal: action.payload
        }
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_EDIT_CHANGE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              ...action.payload
            }
          }
        }
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            ...action.payload,
          },
          update: {
            ...state.update,
            loading: true,
            response: '',
            message: ''
          }
        }
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE_SUCCESS:
      return {
        ...state,
        edit: { 
          ...state.edit,
          modal: false,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              update_reason: ''
            },
            old: {
              ...state.edit.data.new,
              update_reason: ''
            }
          },
          update: {
            ...state.update,
            loading: false,
            response: 'success',
            message: action.payload
          }
        },
        view: {
          ...state.view,
          modal: false
        }
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          update: {
            ...state.update,
            loading: false,
            response: 'error',
            message: action.payload
          }
        }
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_VIEW_TAB_SET:
      return {
        ...state,
        view: {
          ...state.view,
          tab: action.payload
        }
      }
    case EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET:
      return { ...state };
    case EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET_SUCCESS:
      return {
        ...state,
        file: [...state.file, action.payload]
      };
    case EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET_ERROR:
      return { 
        ...state,
        file: [...state.file, action.payload]
      };
    case EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_RESET:
      return {
        ...state,
        file: []
      };
    default:
      return { ...state };
    }

};